<script lang="ts">
    export let primary = false;
    export let dark = false;
    export let disabled = false;
    export let paddedType = "ultra";
    export let ariaLabel = "";
    export let type: "button" | "submit" | "reset" | null | undefined = "button";
    export let classNames = "";
    export let rounded = true;
</script>

<button
    aria-label={ariaLabel}
    {disabled}
    {type}
    class:rounded-sm={rounded}
    class:primary
    class:secondary={!primary}
    class:dark
    class:padded-ultra={!paddedType || paddedType === "ultra"}
    class:padded-normal={paddedType === "normal"}
    class:padded-tiny={paddedType === "tiny"}
    class={classNames}
    on:click
>
    <slot />
</button>

<style>
    button {
        margin: 0;
        font-weight: 800;
        font-size: 1rem;
        cursor: pointer;
        font-family: Oswald, Helvetica Neue, Arial, sans-serif;
        text-transform: uppercase;
        text-align: center;
        touch-action: manipulation;
        outline: none;
    }
    .secondary {
        color: #fafafa;
        background-color: transparent;
    }
    .secondary.border {
        border: 1px solid #fafafa;
    }

    .secondary.dark {
        color: #333;
        background-color: transparent;
    }

    .primary {
        color: rgba(255, 255, 255);
        background: none repeat scroll 0 0 #000000;
        border-radius: 8px;
    }
    .primary.border {
        border: 1px solid #000000;
    }
    .primary:hover {
        background: none repeat scroll 0 0 #393939;
    }

    .primary:disabled {
        color: #eee;
        background: none repeat scroll 0 0 #bbc0b7;
    }
    .primary:disabled.border {
        border: 1px solid #bbc0b7;
    }
    button.padded-ultra {
        padding: 10px;
    }
    button.padded-normal {
        padding: 4px;
    }
    button.padded-tiny {
        padding: 1px 4px;
    }
</style>
